/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ILandingPageConfigurationScope extends angular.IScope {
        model: models.LandingPageConfigurationModel;
    }

    export class LandingPageConfigurationController implements IController {
        scope: ILandingPageConfigurationScope;

        constructor(
            $scope: ILandingPageConfigurationScope,
            landingPageConfigurationService: services.LandingPageConfigurationService,
            contentPageService: services.ContentPageService,
            securityMatrixService: services.SecurityMatrixService,
            processTypeService: services.ProcessTypeService,
            modalService: any,
            growlService: angular.growl.IGrowlService) {
            this.scope = $scope;
            this.scope.model = new models.LandingPageConfigurationModel(
                landingPageConfigurationService,
                contentPageService,
                securityMatrixService,
                processTypeService,
                modalService,
                growlService);
        }
    }
}

warsApp.registerController('LandingPageConfigurationController', ['$scope', 'landingPageConfigurationService', 'contentPageService', 'securityMatrixService', 'processTypeService', 'ModalService', 'growl']);